<template></template>

<script>
    import { POINT_MARKER_ICON_CONFIG } from '@/constants/mapSettings.js'

    export default {
        props: {
            google: {
                type: Object,
                required: true
            },
            map: {
                type: Object,
                required: true
            },
            bounds: {
                type: Object,
                required: true
            },
            label: {
                type: String
            },
            marker: {
                type: Object,
                required: true
            },
            innactive: {
                type: Boolean,
            },
            googleMapMarkers: {
                type: Array
            },
            pulse: {
                type: Boolean
            },
            numberMarks: {
                type: Number
            }
        },

        data () {
            return { googleMarker: null }
        },

        methods: {
            fadeInMarker (marker, markerOpacity, direction) {
                const markerOpacityIncrement = 0.03
                if (direction === 'UP') {
                    if (markerOpacity >= 1) {
                        direction = 'DOWN'
                    } else {
                        marker.setOpacity(markerOpacity)
                        markerOpacity += markerOpacityIncrement
                    }
                } else {
                    if (markerOpacity <= 0) {
                        direction = 'UP'
                    } else {
                        marker.setOpacity(markerOpacity)
                        markerOpacity -= markerOpacityIncrement
                    }
                }
                setTimeout(() => {
                    this.fadeInMarker(marker, markerOpacity, direction)
                }, 50)
            },

            setMarker (marker) {
                const { Marker } = this.google.maps

                this.googleMarker = new Marker({
                    position: marker.location,
                    marker: marker,
                    map: this.map,
                    label: {
                        color: 'black',
                        fontWeight: 'bold',
                        text: this.label,
                    },
                    clickHandler: this.clickHandler,
                    icon: {
                        url: "/routerfond.png",
                        labelOrigin: new google.maps.Point(17, 50),
                    }
                })

                this.bounds.extend(this.googleMarker.getPosition())
                
                this.googleMarker.addListener('click', () => {
                    this.$emit('selectMarker', marker, this.googleMarker)
                })

                this.googleMapMarkers.push(this.googleMarker)

                if (this.googleMarker.pulse) {
                    this.fadeInMarker(this.googleMarker, 0, 'UP')
                }
                
                if (this.numberMarks == this.googleMapMarkers.length)
                    this.map.fitBounds(this.bounds)
            }
        },

        watch: {
            marker (val) {
                this.setMarker(val)
            },
        },
        mounted() {
            this.setMarker(this.marker)
        }
    }
</script>
